import React, { useEffect, useState } from 'react';
import { Button, Frame, ProgressBar } from 'react95';

const devices = [
  ['处理器', '单核，多愁善感。', '靠白日梦驱动，以 95 MHz 的频率胡思乱想。'],
  ['内存', '640 KB 的怀旧容量。', '其中 639 KB 留给那些以为早已忘记的事。'],
  ['显示器', '自带回忆滤镜的 CRT。', '支持一千六百万种颜色，晚霞却总是粉色。'],
  ['存储', '本地梦境磁盘（C:）。', '存有尚未保存的夏天，请勿整理碎片。', '仅供怀旧。'],
  ['散热', '窗外的风。🍃', '正在安静工作，无需更新驱动。']
];

const diagnosticSteps = [
  '时钟检查完成：时间仍停在某个夏天。',
  '音频检查完成：建议把世界的音量调低一点。',
  '磁盘检查完成：发现尚未保存的白日梦。💭',
  '诊断完成：你不需要修复，休息一下就好。'
];

export function HardwarePanel() {
  return (
    <div className="system-extra-panel">
      <div className="system-panel-heading">
        <span className="system-channel" aria-hidden="true">02 / HARDWARE</span>
        <h2>想象中的设备管理器</h2>
        <p>所有设备都在凭感情正常运转。</p>
      </div>
      <div className="system-devices">
        {devices.map(([name, summary, description, purpose], index) => (
          <details key={name}>
            <summary><span className="system-device-number" aria-hidden="true">0{index + 1}</span>{name}</summary>
            <div className="system-device-properties">
              <p><strong>{summary}</strong></p>
              <p>{description}</p>
              {purpose && <p>用途：{purpose}</p>}
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}

export function DiagnosticsPanel() {
  const [completedSteps, setCompletedSteps] = useState(0);
  const [running, setRunning] = useState(false);
  const [repaired, setRepaired] = useState(false);

  useEffect(() => {
    if (!running) return undefined;
    const timer = setInterval(() => {
      setCompletedSteps(count => Math.min(count + 1, diagnosticSteps.length));
    }, 700);
    return () => clearInterval(timer);
  }, [running]);

  useEffect(() => {
    if (completedSteps === diagnosticSteps.length) setRunning(false);
  }, [completedSteps]);

  function runDiagnostics() {
    setCompletedSteps(0);
    setRepaired(false);
    setRunning(true);
  }

  return (
    <div className="system-extra-panel">
      <div className="system-panel-heading">
        <span className="system-channel" aria-hidden="true">03 / DIAGNOSTICS</span>
        <h2>怀旧系统诊断</h2>
        <p>检查虚构的硬件，以及真实的白日梦。</p>
      </div>
      <div className="system-scan-meter">
        <span>扫描进度</span>
        <ProgressBar
          className="system-progress"
          aria-label="扫描进度"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuetext={`${completedSteps} / ${diagnosticSteps.length}`}
          value={completedSteps / diagnosticSteps.length * 100}
          hideValue
        />
        <span>{completedSteps} / {diagnosticSteps.length}</span>
      </div>
      <Frame variant="field" className="system-diagnostic-log" role="log" aria-label="诊断结果" aria-live="polite">
        {!completedSteps && <p>{running ? '正在听风扇转动的声音……' : '准备好了，随时开始。'}</p>}
        {diagnosticSteps.slice(0, completedSteps).map((step, index) => <p key={step}><span className="system-log-number" aria-hidden="true">0{index + 1}</span>{step}</p>)}
        {repaired && <p className="system-repair-message">修复完成：已批准你暂时什么也不做。🌱</p>}
      </Frame>
      <div className="system-diagnostic-actions">
        <Button onClick={runDiagnostics} disabled={running}>{running ? '正在扫描…' : '开始诊断'}</Button>
        <Button onClick={() => setRepaired(true)} disabled={running || completedSteps !== diagnosticSteps.length || repaired}>
          {repaired ? '已治愈' : '修复一下'}
        </Button>
      </div>
    </div>
  );
}

export function CreditsPanel() {
  return (
    <div className="system-extra-panel">
      <div className="system-panel-heading">
        <span className="system-channel" aria-hidden="true">05 / CREDITS</span>
        <h2>由代码与白日梦构成 ✨</h2>
      </div>
      <dl className="system-credits">
        <div><dt>界面引擎</dt><dd>React</dd></div>
        <div><dt>通往过去的窗口</dt><dd>React95</dd></div>
        <div><dt>样式设计部</dt><dd>styled-components</dd></div>
        <div><dt>首席散热工程师</dt><dd>窗外的风</dd></div>
        <div><dt>质量保证</dt><dd>Works on my machine™</dd></div>
        <div><dt>软盘福利</dt><dd>制作过程中，没有软盘受到伤害。</dd></div>
        <div className="system-special-thanks"><dt>特别感谢</dt><dd>❤ 谢谢你来到这里 ❤</dd></div>
      </dl>
    </div>
  );
}
